import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_3 = {
  key: 1,
  class: "rounded-lg border border-gray-200 bg-white p-5 text-gray-500"
}
const _hoisted_4 = { class: "flex flex-wrap justify-between gap-3" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 text-sm md:grid-cols-3" }
const _hoisted_7 = { class: "text-gray-400" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "text-gray-400" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "text-gray-400" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { onMounted, ref } from "vue";
import { t } from "@/i18n";
import EnbekDataService from "@/services/enbek/EnbekDataService";
import { EnbekRegistration } from "@/types/enbek/Enbek";
import EnbekStatusBadge from "./EnbekStatusBadge.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as { userId: string | number }


const loading = ref(true);
const items = ref<EnbekRegistration[]>([]);
onMounted(async () => {
  try {
    items.value =
      (await EnbekDataService.byEmployee(props.userId)).data.data || [];
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("common.loading")), 1))
      : (!items.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("enbek.noRegistrations")), 1))
        : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "rounded-lg border border-gray-200 bg-white p-5 space-y-3"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.contractNumber) + " · " + _toDisplayString(item.positionName), 1),
          _createVNode(EnbekStatusBadge, {
            status: item.status
          }, null, 8, ["status"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("enbek.employer")), 1),
            _hoisted_8,
            _createTextVNode(_toDisplayString(item.employerName) + " · " + _toDisplayString(item.employerBin), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("enbek.period")), 1),
            _hoisted_10,
            _createTextVNode(_toDisplayString(item.beginDate) + " — " + _toDisplayString(item.endDate || _unref(t)("enbek.indefinite")), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("enbek.externalId")), 1),
            _hoisted_12,
            _createTextVNode(_toDisplayString(item.externalContractId || "—"), 1)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})